import React, { useEffect, useState } from "react";
import { Form, Input, Button, Row, Col, Space, Modal, Drawer } from "antd";
import { CloseCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { FormattedMessage, useIntl } from "react-intl";
import AttachmentComponent from "CommonComponents/Attachments/Attachments";
import { useDispatch } from "react-redux";
import { addLeadNoteAPI, editLeadNoteAPI } from "../LeadsAPI";
import { useParams } from "react-router-dom";
import FormType from "features/Enums/FormType";

const { TextArea } = Input;

const LeadNoteForm = (props) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { leadId } = useParams();
  const intl = useIntl();
  const formTypeId = Object.values(FormType).find(
    (f) => f.name === "LeadNotes"
  )?.id;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props?.note) {
      form.setFieldsValue({
        title: props?.note.title,
        note: props?.note.note,
      });
    } else {
      form.resetFields();
    }
  }, [props?.note, form]);

  const handleSubmit = async (values) => {
    const noteData = {
      id: props?.note?.id || 0,
      leadId: leadId,
      title: values.title,
      note: values.note,
    };
    setLoading(true);
    const action = props?.note ? editLeadNoteAPI : addLeadNoteAPI;
    await dispatch(action(noteData, leadId));
    form.resetFields();
    props?.onClose();
    setLoading(false);
  };

  const onCancel = () => {
    if (form.isFieldsTouched()) {
      Modal.confirm({
        title: intl.formatMessage({ id: "LeadNote.CancelConfirmation" }),
        okText: intl.formatMessage({ id: "Common.Yes" }),
        cancelText: intl.formatMessage({ id: "Common.No" }),
        onOk: () => {
          form.resetFields();
          props?.onClose();
        },
      });
    } else {
      props?.onClose();
    }
  };

  return (
    <Drawer
      open={props?.drawerVisible}
      onClose={props?.onClose}
      width={500}
      title={
        props?.note ? (
          <FormattedMessage id="LeadNote.EditLeadNote" />
        ) : (
          <FormattedMessage id="LeadNote.AddLeadNote" />
        )
      }
    >
      <Form
        form={form}
        layout="vertical"
        size="large"
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Form.Item
          label={<FormattedMessage id="LeadNote.Title" />}
          name="title"
          rules={[
            {
              required: true,
              message: intl.formatMessage({ id: "LeadNote.Error.EnterTitle" }),
            },
          ]}
        >
          <Input
            maxLength={100}
            placeholder={intl.formatMessage({
              id: "LeadNote.Placeholder.EnterTitle",
            })}
          />
        </Form.Item>

        <Form.Item
          label={<FormattedMessage id="LeadNote.Note" />}
          name="note"
          rules={[
            {
              required: true,
              message: intl.formatMessage({ id: "LeadNote.Error.EnterNotes" }),
            },
          ]}
        >
          <TextArea
            rows={4}
            maxLength={255}
            showCount
            placeholder={intl.formatMessage({
              id: "LeadNote.Placeholder.EnterNotes",
            })}
          />
        </Form.Item>

        <Form.Item label={<FormattedMessage id="Common.Attachment" />}>
          <AttachmentComponent
            identifier={formTypeId}
            currentId={props?.note ? props?.note.id : null}
            getattachments={true}
          />
        </Form.Item>

        <Row justify="center" className="mt-10">
          <Space>
            <Button
              danger
              onClick={onCancel}
              icon={<CloseCircleOutlined />}
              disabled={loading}
            >
              <CloseCircleOutlined /> <FormattedMessage id="Common.Cancel" />
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              icon={<CheckCircleOutlined />}
              loading={loading}
            >
              <CheckCircleOutlined /> <FormattedMessage id="Common.Save" />
            </Button>
          </Space>
        </Row>
      </Form>
    </Drawer>
  );
};

export default LeadNoteForm;
